import { CustomType } from "app/core/shared/shared.type";

export const dataModelData: CustomType[] = [
  {
    id: 'wm',
    label: 'Wireline Mast',
    value: 'Wireline Mast'
  },
  {
    id: 'hd',
    label: 'Hydraulic',
    value: 'Hydraulic'
  }
]
